<% const userData = user && user.data ? user.data : {}; %>

<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 class="card-title mb-0">Account Settings</h4>
            </div>
        </div>

        <ul class="nav nav-pills user-profile-tab border-bottom" id="accountTabs" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 active d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="account-tab" data-tab-target="#pills-profile"
                        type="button" role="tab" aria-controls="pills-profile" aria-selected="true">
                    <i class="ti ti-user me-2 fs-6"></i>
                    <span class="d-none d-md-block">Profile</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="account-tab" data-tab-target="#pills-security"
                        type="button" role="tab" aria-controls="pills-security" aria-selected="false">
                    <i class="ti ti-lock me-2 fs-6"></i>
                    <span class="d-none d-md-block">Security</span>
                </button>
            </li>
        </ul>

        <div class="tab-content pt-4" id="accountTabContent">
            <!-- Profile Tab -->
            <div class="tab-pane fade show active" id="pills-profile" role="tabpanel" tabindex="0">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="mb-0">Profile Information</h5>
                    <div>
                        <button type="button" class="btn btn-outline-primary me-2" data-type="change-email">
                            <i class="ti ti-mail me-1"></i>Change Email
                        </button>
                        <button type="button" class="btn btn-primary" data-type="edit-profile">
                            <i class="ti ti-pencil me-1"></i>Edit
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Name</label>
                            <p class="mb-0 fs-4 fw-medium"><%= user?.name || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Email</label>
                            <p class="mb-0 fs-4 fw-medium"><%= user?.email || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Organisation</label>
                            <p class="mb-0 fs-4 fw-medium"><pre><%= user?.organisationId || '---' %></pre></p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Role</label>
                            <p class="mb-0 fs-4 fw-medium"><%= user?.rolename || '---' %></p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label text-muted text-uppercase fw-bold detail-label">Registration Date</label>
                            <p class="mb-0 fs-4 fw-medium"><%= user?.createdAt ? new Date( user.createdAt ).toLocaleDateString() : '---' %></p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Security Tab -->
            <div class="tab-pane fade" id="pills-security" role="tabpanel" tabindex="0">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="mb-0">Change Password</h5>
                </div>
                <form id="change-password-form">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Current Password</label>
                                <input type="password" class="form-control" id="current-password" placeholder="Enter current password">
                            </div>
                            <div class="mb-3">
                                <label class="form-label">New Password</label>
                                <input type="password" class="form-control" id="new-password" placeholder="Enter new password" minlength="6">
                                <div id="password-strength-meter" class="mt-2" style="display: none;">
                                    <div style="height: 4px; background-color: rgba(189, 200, 240, 0.2); border-radius: 2px; overflow: hidden;">
                                        <div id="password-strength-bar" style="height: 100%; width: 0%; transition: width 0.3s, background-color 0.3s; border-radius: 2px;"></div>
                                    </div>
                                    <small id="password-strength-text" class="mt-1 d-block"></small>
                                </div>
                                <div id="password-length-error" class="text-danger mt-1" style="display: none;">
                                    <small>Password must be at least 6 characters</small>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Confirm New Password</label>
                                <input type="password" class="form-control" id="confirm-password" placeholder="Confirm new password">
                                <div id="password-match-error" class="text-danger mt-1" style="display: none;">
                                    <small>Passwords do not match</small>
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary" data-type="save-password">
                                Update Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<!-- Edit Profile Modal -->
<div class="modal fade" id="editProfileModal" tabindex="-1" aria-labelledby="editProfileModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editProfileModalLabel">Edit Profile</h5>
                <button type="button" class="btn-close" data-type="profile-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="edit-profile-form">
                    <div class="mb-3">
                        <label class="form-label">Name <span class="text-danger">*</span></label>
                        <input type="text"
                               class="form-control"
                               id="edit-profile-name"
                               value="<%= userData.name || '' %>"
                               placeholder="Enter your name"
                               required>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="profile-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="profile-modal-save">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Change Email Modal -->
<div class="modal fade" id="changeEmailModal" tabindex="-1" aria-labelledby="changeEmailModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="changeEmailModalLabel">Change Email Address</h5>
                <button type="button" class="btn-close" data-type="email-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="text-muted mb-3">A confirmation link will be sent to your new email address. Your email will not change until you confirm it.</p>
                <form id="change-email-form">
                    <div class="mb-3">
                        <label class="form-label">Current Email</label>
                        <input type="email" class="form-control" value="<%= user?.email || '' %>" disabled>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">New Email <span class="text-danger">*</span></label>
                        <input type="email"
                               class="form-control"
                               id="change-email-new"
                               placeholder="Enter new email address"
                               required>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Password <span class="text-danger">*</span></label>
                        <input type="password"
                               class="form-control"
                               id="change-email-password"
                               placeholder="Enter your password to confirm"
                               required>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="email-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="email-modal-save">Send Confirmation</button>
            </div>
        </div>
    </div>
</div>
